import { useEffect } from 'react';
import { Card } from 'reactstrap'

import handlebars from "handlebars"

import '../../assets/tcpa-preview.css';

const SCRIPT_CHECKBOXES = `
  document.querySelector('#leadid_tcpa_disclosure').addEventListener('change', function() {
    var isChecked = this.checked;
    var dbaCheckboxes = document.querySelectorAll('.tcpa-consent-dba');
    dbaCheckboxes.forEach(function(checkbox) {
      checkbox.checked = isChecked;
    });
  });
`

export default function TcpaConsentDbaPreview({ dbas, html }) {
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = SCRIPT_CHECKBOXES;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const tcpaconsent_maincheckbox = `<input type="checkbox" class="tcpa-checkbox chkbox path-dynamic-field" id="leadid_tcpa_disclosure" name="chktcpa">`

  const tcpaconsent_checkbox = ({ value, label, classes = '', renderLabel = true }) => `<input class="tcpa-checkbox tcpa-consent-dba ${classes}" type="checkbox" data-id="${value}"> ${renderLabel ? label : ''}`

  const tcpaconsent = options => {
    const { dbas } = options.data.root
    if (!options.fn) {
      const content = dbas.map(tcpaconsent_checkbox).join('')
      return handlebars.compile(content)(options)
    }

    let content = ''
    for (const dba of dbas) {
      options.data.root.dba = dba
      content += options.fn(this)
    }

    return handlebars.compile(content)(options)
  }

  const tcpaconsent_group = options => {
    const { dba } = options.data.root
    if (!options.fn) {
      const content = tcpaconsent_checkbox(dba)
      return handlebars.compile(content)(options)
    }

    return handlebars.compile(options.fn(this))(options)
  }

  const tcpaconsent_input = options => {
    const { dba } = options.data.root
    return handlebars.compile(`<input class="tcpa-checkbox tcpa-consent-dba ${options.hash.class || ''}" type="checkbox" data-id="${dba.value}">`)(options)
  }

  const tcpaconsent_label = options => {
    const { dba } = options.data.root
    return handlebars.compile(`<label class="tcpa-label ${options.hash.class || ''}">${dba.label}</label>`)(options)
  }

  handlebars.registerHelper('tcpaconsent', tcpaconsent)
  handlebars.registerHelper('tcpaconsent_group', tcpaconsent_group)
  handlebars.registerHelper('tcpaconsent_input', tcpaconsent_input)
  handlebars.registerHelper('tcpaconsent_label', tcpaconsent_label)

  let processedHtml = ''
  try {
    const template = handlebars.compile(html)
    processedHtml = tcpaconsent_maincheckbox + template({ dbas })
  } catch (error) {
    processedHtml = ''
  }

  return <>
    <p className='my-3'>The DBAs will be rendered this way</p>
    <Card className='py-3 px-2'>
      <div className='main-label'>
        <div dangerouslySetInnerHTML={{ __html: processedHtml }} />
      </div>
    </Card>
  </>
}

